export default class fnPackageCtrl {
    constructor($scope, httpRequest, $state, sweetalert, logger) {
        $scope.queryParam = {
            pageNum: 1,
            pageSize: 10,
            param: {
                packName: '',
                packStatus: '',
            },
        }
        $scope.reset = function () {
            $scope.queryParam.param = {
                packName: '',
                packStatus: '',
            }
        }
        // $scope.reset()
        $scope.queryList = function queryList() {
            httpRequest.post_getSysPackList($scope.queryParam).then((res) => {
                $scope.listData = res.data.value.list
                $scope.totalItems = res.data.value.total
            })
        }
        $scope.queryList()
        httpRequest.get_dictByTypeArr(['pack_status']).then((res) => {
            $scope.dictionary = res.data.value
        })
        // 表格下拉框
        $scope.tableDropdownConfig = [
            {
                label: '发布',
                handler(item) {
                    sweetalert.confirm('操作提醒', '确认发布此功能包？').then(() => {
                        httpRequest.post_publishSysPack({
                            packId: item.packId,
                            packStatus: 0,
                        }).then(() => {
                            logger.logSuccess('发布成功')
                            $scope.queryList()
                        })
                    })
                },
                showWhile(item) {
                    return item.packStatus != 0
                },
            }, {
                label: '下架',
                handler(item) {
                    sweetalert.confirm('操作提醒', '确认下架此功能包？').then(() => {
                        httpRequest.post_publishSysPack({
                            packId: item.packId,
                            packStatus: 1,
                        }).then(() => {
                            logger.logSuccess('下架成功')
                            $scope.queryList()
                        })
                    })
                },
                showWhile(item) {
                    return item.packStatus == 0
                },
            }, {
                label: '编辑',
                handler(item) {
                    $state.go('system.syssetting.fnPackage.edit', { packId: item.packId })
                },
                showWhile(item) {
                    return item.packStatus != 0
                },
            },
        ]
        $scope.add = function add() {
            $state.go('system.syssetting.fnPackage.add')
        }
    }
}
fnPackageCtrl.$inject = ['$scope', 'httpRequest', '$state', 'sweetalert', 'logger']



// WEBPACK FOOTER //
// ./src/app/system/systemsetting/fnPackage/list.js